import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.75 5.813H2.25a.567.567 0 0 1-.562-.563c0-.308.254-.562.562-.562h13.5c.308 0 .563.255.563.562a.567.567 0 0 1-.563.563M15.75 9.563H2.25A.567.567 0 0 1 1.688 9c0-.307.254-.562.562-.562h13.5c.308 0 .563.255.563.562a.567.567 0 0 1-.563.563M15.75 13.313H2.25a.567.567 0 0 1-.562-.563c0-.307.254-.562.562-.562h13.5c.308 0 .563.255.563.562a.567.567 0 0 1-.563.563"
    }, null, -1)
  ]))]))
}
export default { render: render }